"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var store_1 = __importDefault(require("~/components/click_transfer_recommended/store"));
var use_before_pop_state_event_1 = require("@hikakaku/shared/hooks/use_before_pop_state_event");
var DISPLAYABLE_STORE_LIMIT = 3;
var ClickTransferRecommendedStores = function (props) {
    var _a = react_1.default.useState(false), open = _a[0], setIsOpen = _a[1];
    var leavePage = (0, use_before_pop_state_event_1.useBeforePopStateEvent)(function () { return setIsOpen(true); });
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: open, onClose: function () { return setIsOpen(false); }, classNames: { modal: 'coModalBeforePopStateClickTransferRecommendedStores-Container' } },
        react_1.default.createElement("div", { className: "coModalBeforePopStateClickTransferRecommendedStores-Title" }, props.title),
        react_1.default.createElement("div", { className: "coModalBeforePopStateClickTransferRecommendedStores-List" }, props.clickTransferRecommendedStores.slice(0, DISPLAYABLE_STORE_LIMIT).map(function (storeProps, i) { return (react_1.default.createElement("div", { key: i, className: "coModalBeforePopStateClickTransferRecommendedStores-Item" },
            react_1.default.createElement(store_1.default, __assign({}, storeProps, { isSmartPhone: props.isSmartPhone })))); })),
        react_1.default.createElement("button", { onClick: function () { return leavePage(); }, className: "coModalBeforePopStateClickTransferRecommendedStores-LeavePageButton" }, "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u96E2\u308C\u308B")));
};
exports.default = ClickTransferRecommendedStores;
